import { Typography } from "@mui/material";
import { ParameterConflict } from "store/api/generatedApi";
import { useConflictMessage } from "./parameterConflicts";

export const ConflictDescription = ({
  conflict,
  limitLabel,
}: {
  conflict: ParameterConflict;
  limitLabel: string;
}) => {
  const conflictMessage = useConflictMessage();
  return (
    <>
      <Typography variant="caption" display="block">
        {conflictMessage(conflict, limitLabel)}
      </Typography>
      {conflict.steel_grade_names.length > 1 ? (
        <Typography variant="caption" display="block" sx={{ opacity: 0.8 }}>
          {conflict.steel_grade_names.join(", ")}
        </Typography>
      ) : null}
    </>
  );
};
